import React from 'react';

const Wrapper: React.FC<React.ComponentProps<'span'>> = ({ children, ...props }) => {
  return (
    <span className="anticon custom-icon" {...props}>
      {children}
    </span>
  );
};

const DashBoardIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M3.15625 2.44922C4.78906 0.816406 6.73698 0 9 0C11.263 0 13.1966 0.816406 14.8008 2.44922C16.4336 4.05339 17.25 5.98698 17.25 8.25C17.25 10.513 16.4336 12.4609 14.8008 14.0938C13.1966 15.6979 11.263 16.5 9 16.5C6.73698 16.5 4.78906 15.6979 3.15625 14.0938C1.55208 12.4609 0.75 10.513 0.75 8.25C0.75 5.98698 1.55208 4.05339 3.15625 2.44922ZM13.8555 3.39453C12.5091 2.04818 10.8906 1.375 9 1.375C7.10938 1.375 5.49089 2.04818 4.14453 3.39453C2.79818 4.74089 2.125 6.35938 2.125 8.25C2.125 10.1406 2.79818 11.7591 4.14453 13.1055C5.49089 14.4518 7.10938 15.125 9 15.125C10.8906 15.125 12.5091 14.4518 13.8555 13.1055C15.2018 11.7591 15.875 10.1406 15.875 8.25C15.875 6.35938 15.2018 4.74089 13.8555 3.39453ZM8.48438 2.27734C8.6276 2.13411 8.79948 2.0625 9 2.0625C9.20052 2.0625 9.35807 2.13411 9.47266 2.27734C9.61589 2.39193 9.6875 2.54948 9.6875 2.75C9.6875 2.95052 9.61589 3.1224 9.47266 3.26562C9.35807 3.38021 9.20052 3.4375 9 3.4375C8.79948 3.4375 8.6276 3.38021 8.48438 3.26562C8.36979 3.1224 8.3125 2.95052 8.3125 2.75C8.3125 2.54948 8.36979 2.39193 8.48438 2.27734ZM4.61719 3.91016C4.76042 3.76693 4.91797 3.69531 5.08984 3.69531C5.29036 3.69531 5.46224 3.76693 5.60547 3.91016C5.7487 4.02474 5.82031 4.18229 5.82031 4.38281C5.82031 4.55469 5.7487 4.71224 5.60547 4.85547C5.46224 4.9987 5.29036 5.07031 5.08984 5.07031C4.91797 5.07031 4.76042 4.9987 4.61719 4.85547C4.5026 4.71224 4.44531 4.55469 4.44531 4.38281C4.44531 4.18229 4.5026 4.02474 4.61719 3.91016ZM12.3945 3.86719L13.3828 4.85547L10.332 7.90625C10.3607 8.02083 10.375 8.13542 10.375 8.25C10.375 8.6224 10.2318 8.95182 9.94531 9.23828C9.6875 9.49609 9.3724 9.625 9 9.625C8.6276 9.625 8.29818 9.49609 8.01172 9.23828C7.75391 8.95182 7.625 8.6224 7.625 8.25C7.625 7.8776 7.75391 7.5625 8.01172 7.30469C8.29818 7.01823 8.6276 6.875 9 6.875C9.11458 6.875 9.22917 6.88932 9.34375 6.91797L12.3945 3.86719ZM2.98438 7.77734C3.1276 7.63411 3.29948 7.5625 3.5 7.5625C3.70052 7.5625 3.85807 7.63411 3.97266 7.77734C4.11589 7.89193 4.1875 8.04948 4.1875 8.25C4.1875 8.45052 4.11589 8.6224 3.97266 8.76562C3.85807 8.88021 3.70052 8.9375 3.5 8.9375C3.29948 8.9375 3.1276 8.88021 2.98438 8.76562C2.86979 8.6224 2.8125 8.45052 2.8125 8.25C2.8125 8.04948 2.86979 7.89193 2.98438 7.77734ZM13.9844 7.77734C14.1276 7.63411 14.2995 7.5625 14.5 7.5625C14.7005 7.5625 14.8581 7.63411 14.9727 7.77734C15.1159 7.89193 15.1875 8.04948 15.1875 8.25C15.1875 8.45052 15.1159 8.6224 14.9727 8.76562C14.8581 8.88021 14.7005 8.9375 14.5 8.9375C14.2995 8.9375 14.1276 8.88021 13.9844 8.76562C13.8698 8.6224 13.8125 8.45052 13.8125 8.25C13.8125 8.04948 13.8698 7.89193 13.9844 7.77734ZM4.61719 11.6445C4.76042 11.5013 4.91797 11.4297 5.08984 11.4297C5.29036 11.4297 5.46224 11.5013 5.60547 11.6445C5.7487 11.7878 5.82031 11.9596 5.82031 12.1602C5.82031 12.332 5.7487 12.4896 5.60547 12.6328C5.46224 12.7474 5.29036 12.8047 5.08984 12.8047C4.91797 12.8047 4.76042 12.7474 4.61719 12.6328C4.5026 12.4896 4.44531 12.332 4.44531 12.1602C4.44531 11.9596 4.5026 11.7878 4.61719 11.6445ZM12.3945 11.6445C12.5378 11.5013 12.6953 11.4297 12.8672 11.4297C13.0677 11.4297 13.2253 11.5013 13.3398 11.6445C13.4831 11.7878 13.5547 11.9596 13.5547 12.1602C13.5547 12.332 13.4831 12.4896 13.3398 12.6328C13.2253 12.7474 13.0677 12.8047 12.8672 12.8047C12.6953 12.8047 12.5378 12.7474 12.3945 12.6328C12.2513 12.4896 12.1797 12.332 12.1797 12.1602C12.1797 11.9596 12.2513 11.7878 12.3945 11.6445Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const CallCenterIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M6 6.5C6 5.96875 5.53125 5.5 5 5.5H4.5C3.375 5.5 2.5 6.40625 2.5 7.5V9C2.5 10.125 3.375 11 4.5 11H5C5.53125 11 6 10.5625 6 10V6.5ZM11.5 11C12.5938 11 13.5 10.125 13.5 9V7.5C13.5 6.40625 12.5938 5.5 11.5 5.5H11C10.4375 5.5 10 5.96875 10 6.5V10C10 10.5625 10.4375 11 11 11H11.5ZM8 0C3.53125 0 0.125 3.71875 0 8V8.5C0 8.78125 0.21875 9 0.5 9H1C1.25 9 1.5 8.78125 1.5 8.5V8C1.5 4.4375 4.40625 1.5 8 1.5C11.5625 1.5 14.5 4.4375 14.5 8H14.4688C14.4688 8.09375 14.5 13.1875 14.5 13.1875C14.5 13.9375 13.9062 14.5 13.1562 14.5H10C10 13.6875 9.3125 13 8.5 13H7.5C6.65625 13 6 13.6875 6 14.5C6 15.3438 6.65625 16 7.5 16H13.1562C14.7188 16 16 14.75 16 13.1875V8C15.8438 3.71875 12.4375 0 8 0Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const SocialMediaIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M12.375 11.25C11.3555 11.25 10.4414 11.707 9.84375 12.4102L6.46875 10.3008C6.82031 9.49219 6.82031 8.54297 6.46875 7.73438L9.84375 5.625C10.4414 6.32812 11.3555 6.75 12.375 6.75C14.2383 6.75 15.75 5.23828 15.75 3.375C15.75 1.51172 14.2383 0 12.375 0C10.5117 0 9 1.51172 9 3.375C9 3.83203 9.07031 4.28906 9.24609 4.67578L5.87109 6.78516C5.27344 6.08203 4.35938 5.625 3.375 5.625C1.51172 5.625 0 7.13672 0 9C0 10.8633 1.51172 12.375 3.375 12.375C4.35938 12.375 5.27344 11.9531 5.87109 11.25L9.24609 13.3594C9.07031 13.7461 9 14.168 9 14.625C9 16.4883 10.5117 18 12.375 18C14.2383 18 15.75 16.4883 15.75 14.625C15.75 12.7617 14.2383 11.25 12.375 11.25ZM12.375 1.125C13.6055 1.125 14.625 2.14453 14.625 3.375C14.625 4.64062 13.6055 5.625 12.375 5.625C11.1094 5.625 10.125 4.64062 10.125 3.375C10.125 2.14453 11.1094 1.125 12.375 1.125ZM3.375 11.25C2.10938 11.25 1.125 10.2656 1.125 9C1.125 7.76953 2.10938 6.75 3.375 6.75C4.60547 6.75 5.625 7.76953 5.625 9C5.625 10.2656 4.60547 11.25 3.375 11.25ZM12.375 16.875C11.1094 16.875 10.125 15.8906 10.125 14.625C10.125 13.3945 11.1094 12.375 12.375 12.375C13.6055 12.375 14.625 13.3945 14.625 14.625C14.625 15.8906 13.6055 16.875 12.375 16.875Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const InvoicesIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="14"
        height="17"
        viewBox="0 0 14 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M5.07031 1.375C5.44271 0.458333 6.04427 0 6.875 0C7.70573 0 8.30729 0.458333 8.67969 1.375H10.3125H11H13.0625H13.75V2.0625V16.5V17.1875H13.0625H0.6875H0V16.5V2.0625V1.375H0.6875H2.75H3.4375H5.07031ZM7.34766 1.58984C7.23307 1.44661 7.07552 1.375 6.875 1.375C6.67448 1.375 6.5026 1.44661 6.35938 1.58984C6.24479 1.70443 6.1875 1.86198 6.1875 2.0625V2.75H5.5H4.125V4.125H9.625V2.75H8.25H7.5625V2.0625C7.5625 1.86198 7.49089 1.70443 7.34766 1.58984ZM1.375 2.75V15.8125H12.375V2.75H11V4.8125V5.5H10.3125H3.4375H2.75V4.8125V2.75H1.375Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const ParingIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M9.41406 12.3203C10.9766 10.7578 10.9766 8.16406 9.41406 6.57031C9.00781 6.19531 8.57031 5.91406 8.10156 5.69531C7.91406 5.63281 7.66406 5.72656 7.60156 5.94531C7.57031 6.07031 7.53906 6.28906 7.50781 6.41406C7.50781 6.57031 7.60156 6.72656 7.75781 6.78906C8.07031 6.91406 8.35156 7.13281 8.60156 7.38281C9.75781 8.50781 9.75781 10.3828 8.63281 11.5078L8.60156 11.5391L6.13281 14.0078C4.97656 15.1641 3.13281 15.1641 1.97656 14.0078C0.820312 12.8516 0.820312 11.0078 1.97656 9.85156C1.97656 9.85156 3.82031 8.00781 4.32031 7.50781C4.41406 7.41406 4.44531 7.28906 4.44531 7.19531C4.41406 7.03906 4.41406 6.88281 4.41406 6.72656C4.38281 6.41406 4.00781 6.25781 3.75781 6.47656C3.72656 6.50781 3.69531 6.53906 3.66406 6.57031L1.19531 9.07031C-0.398438 10.6328 -0.398438 13.2266 1.19531 14.7891C2.75781 16.3828 5.35156 16.3828 6.91406 14.7891L9.41406 12.3203ZM6.57031 9.41406C6.97656 9.78906 7.41406 10.0703 7.88281 10.2891C8.07031 10.3516 8.32031 10.2578 8.38281 10.0391C8.41406 9.91406 8.44531 9.69531 8.47656 9.57031C8.47656 9.41406 8.38281 9.25781 8.22656 9.19531C7.91406 9.07031 7.63281 8.85156 7.38281 8.60156C6.22656 7.47656 6.22656 5.60156 7.35156 4.47656L7.38281 4.44531L9.85156 1.97656C11.0078 0.820312 12.8516 0.820312 14.0078 1.97656C15.1641 3.13281 15.1641 4.97656 14.0078 6.13281C14.0078 6.13281 12.1641 7.97656 11.6641 8.47656C11.5703 8.57031 11.5391 8.69531 11.5391 8.78906C11.5703 8.91406 11.5703 9.13281 11.5703 9.25781C11.6016 9.57031 11.9766 9.72656 12.2266 9.50781C12.2578 9.47656 12.2891 9.44531 12.3203 9.41406L14.7891 6.91406C16.3828 5.35156 16.3828 2.75781 14.7891 1.19531C13.2266 -0.398438 10.6328 -0.398438 9.07031 1.19531L6.57031 3.66406C5.00781 5.22656 5.00781 7.82031 6.57031 9.41406Z" fill="#007DA4"/>`,
        }}
      />
    </Wrapper>
  );
};

const SideBarIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      dangerouslySetInnerHTML={{
        __html: `<rect x="0.5" y="0.5" width="19" height="15" rx="1.5" stroke="#707070"/><rect x="6.5" y="0.5" width="13" height="15" rx="1.5" fill="#F8F8F8" stroke="#707070"/><rect x="2" y="2" width="3" height="2" rx="1" fill="#707070"/><rect x="2" y="5" width="3" height="2" rx="1" fill="#707070"/><rect x="2" y="8" width="3" height="2" rx="1" fill="#707070"/>`,
      }}
    />
  );
};

const PrinterIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M15.1875 7H14.625V4.11719C14.625 3.80078 14.4844 3.51953 14.2734 3.30859L11.5664 0.601562C11.3555 0.390625 11.0742 0.25 10.7578 0.25H4.42969C3.83203 0.25 3.375 0.777344 3.375 1.375V7H2.8125C1.23047 7 0 8.26562 0 9.8125V13.1875C0 13.5039 0.246094 13.75 0.5625 13.75H3.375V17.6875C3.375 18.0039 3.62109 18.25 3.9375 18.25H14.0625C14.3438 18.25 14.625 18.0039 14.625 17.6875V13.75H17.4375C17.7188 13.75 18 13.5039 18 13.1875V9.8125C18 8.26562 16.7344 7 15.1875 7ZM11.25 1.86719L13.0078 3.625H11.25V1.86719ZM4.5 1.375H10.125V3.625C10.125 4.25781 10.6172 4.75 11.25 4.75H13.5V7H4.5V1.375ZM13.5 17.125H4.5V13.75H13.5V17.125ZM16.875 12.625H1.125V9.8125C1.125 8.89844 1.86328 8.125 2.8125 8.125H15.1875C16.1016 8.125 16.875 8.89844 16.875 9.8125V12.625ZM14.0625 9.53125C13.5703 9.53125 13.2188 9.91797 13.2188 10.375C13.2188 10.8672 13.5703 11.2188 14.0625 11.2188C14.5195 11.2188 14.9062 10.8672 14.9062 10.375C14.9062 9.91797 14.5195 9.53125 14.0625 9.53125Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const FilterIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="20"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M16.8532 0.993164H1.13831C0.118783 0.993164 -0.373404 2.22363 0.329721 2.92676L6.76331 9.36035V15.8994V15.9346C6.76331 16.2158 6.90394 16.5674 7.11488 16.7783L9.36488 18.7471C10.1032 19.3447 11.2633 18.8525 11.2633 17.8682V9.36035L17.6618 2.92676C18.3649 2.22363 17.8727 0.993164 16.8532 0.993164ZM10.1383 8.86816V17.8682L7.88831 15.8994V8.86816L1.13831 2.11816H16.8883L10.1383 8.86816Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const TagIcon: React.FC<React.ComponentProps<typeof Wrapper>> = (props) => {
  return (
    <Wrapper {...props}>
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M14.5605 6.62109L8.37891 0.439453C8.14453 0.205078 7.70508 0 7.38281 0H1.40625C0.615234 0 0 0.644531 0 1.40625V7.41211C0 7.73438 0.175781 8.17383 0.410156 8.4082L6.5918 14.5898C7.14844 15.1465 8.05664 15.1465 8.58398 14.5898L14.5605 8.61328C15.1172 8.08594 15.1172 7.17773 14.5605 6.62109ZM7.58789 13.5938L1.40625 7.41211V1.40625H7.38281L13.5938 7.61719L7.58789 13.5938ZM5.625 4.21875C5.625 3.45703 4.98047 2.8125 4.21875 2.8125C3.42773 2.8125 2.8125 3.45703 2.8125 4.21875C2.8125 5.00977 3.42773 5.625 4.21875 5.625C4.98047 5.625 5.625 5.00977 5.625 4.21875Z" fill="currentColor"/>`,
        }}
      />
    </Wrapper>
  );
};

const ListViewIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path fill-rule="evenodd" clip-rule="evenodd" d="M0 14.1875V1.8125C0 0.898438 0.738281 0.125 1.6875 0.125H16.3125C17.2266 0.125 18 0.898438 18 1.8125V14.1875C18 15.1367 17.2266 15.875 16.3125 15.875H1.6875C0.738281 15.875 0 15.1367 0 14.1875ZM16.875 5.01172V1.8125C16.875 1.53125 16.5938 1.25 16.3125 1.25H6.75V5.01172V14.75H16.3125C16.5938 14.75 16.875 14.5039 16.875 14.1875V5.01172ZM5.625 6.13672H1.125V9.89844H5.625V6.13672ZM5.625 5.01172V1.25H1.6875C1.37109 1.25 1.125 1.53125 1.125 1.8125V5.01172H5.625ZM1.125 11.0234V14.1875C1.125 14.5039 1.37109 14.75 1.6875 14.75H5.625V11.0234H1.125Z" fill="#007DA4"/>`,
        }}
      />
    </Wrapper>
  );
};

const SingleViewIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M0 1.8125V14.1875C0 15.1367 0.738281 15.875 1.6875 15.875H16.3125C17.2266 15.875 18 15.1367 18 14.1875V1.8125C18 0.898438 17.2266 0.125 16.3125 0.125H1.6875C0.738281 0.125 0 0.898438 0 1.8125ZM8.4375 1.25V7.4375H1.125V1.8125C1.125 1.53125 1.37109 1.25 1.6875 1.25H8.4375ZM1.125 14.1875V8.5625H8.4375V14.75H1.6875C1.37109 14.75 1.125 14.5039 1.125 14.1875ZM9.5625 14.75V8.5625H16.875V14.1875C16.875 14.5039 16.5938 14.75 16.3125 14.75H9.5625ZM16.875 7.4375H9.5625V1.25H16.3125C16.5938 1.25 16.875 1.53125 16.875 1.8125V7.4375Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const AttachmentIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="17"
        height="19"
        viewBox="0 0 17 19"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M4.55273 18.25C5.71289 18.25 6.87305 17.8281 7.75195 16.9492L15.416 9.28516C15.5566 9.10938 15.5566 8.86328 15.416 8.6875L15.2051 8.47656C15.0293 8.33594 14.7832 8.33594 14.6074 8.47656L6.94336 16.1406C5.60742 17.4766 3.46289 17.4766 2.12695 16.1406C0.791016 14.8047 0.791016 12.6602 2.12695 11.3242L11.3379 2.11328C12.2871 1.16406 13.834 1.16406 14.748 2.11328C15.6973 3.02734 15.6973 4.57422 14.748 5.52344L6.94336 13.3633C6.38086 13.8906 5.4668 13.8906 4.9043 13.3633C4.37695 12.8008 4.37695 11.8867 4.9043 11.3242L10.916 5.34766C11.0566 5.17188 11.0566 4.92578 10.916 4.75L10.7051 4.53906C10.5293 4.39844 10.2832 4.39844 10.1074 4.53906L4.13086 10.5508C3.11133 11.5352 3.11133 13.1523 4.13086 14.1367C5.11523 15.1562 6.73242 15.1562 7.7168 14.1367L15.5566 6.33203C16.9277 4.92578 16.9277 2.67578 15.5566 1.30469C14.1855 -0.0664062 11.9355 -0.0664062 10.5293 1.30469L1.31836 10.5156C-0.439453 12.2734 -0.439453 15.1562 1.31836 16.9492C2.19727 17.8281 3.39258 18.25 4.55273 18.25Z"/>`,
        }}
      />
    </Wrapper>
  );
};

const CallBackIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="17"
        height="19"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M8.94531 14.7695L7.96094 12.3086C7.67969 11.6055 6.97656 11.2188 6.27344 11.2891L5.5 11.3594C5.28906 10.375 5.25391 9.32031 5.5 8.30078L6.27344 8.37109C6.97656 8.44141 7.67969 8.05469 7.96094 7.35156L8.94531 4.89062C9.26172 4.15234 8.98047 3.30859 8.27734 2.88672L6.30859 1.65625C5.67578 1.23438 4.83203 1.30469 4.26953 1.86719C-0.0898438 6.26172 -0.125 13.3633 4.26953 17.793C4.83203 18.3555 5.67578 18.4258 6.30859 18.0039L8.27734 16.7734C8.98047 16.3516 9.26172 15.5078 8.94531 14.7695ZM5.46484 16.5625C1.73828 12.8359 1.73828 6.82422 5.46484 3.09766L7.36328 4.29297L6.41406 6.71875L4.30469 6.50781C3.42578 8.93359 3.42578 10.7266 4.30469 13.1523L6.41406 12.9414L7.36328 15.3672L5.46484 16.5625ZM10.9141 3.83594L10.5273 4.22266C10.3867 4.36328 10.3516 4.60938 10.457 4.78516C10.668 5.03125 10.8438 5.55859 10.8438 5.875V5.91016C10.8438 6.22656 10.668 6.75391 10.457 7C10.3516 7.17578 10.3867 7.42188 10.5273 7.5625L10.9141 7.94922C11.0898 8.125 11.4062 8.125 11.5469 7.91406C11.9688 7.35156 12.25 6.64844 12.25 5.875C12.25 5.13672 11.9688 4.43359 11.5469 3.87109C11.4062 3.66016 11.0898 3.66016 10.9141 3.83594ZM14.1133 0.636719L13.7266 1.02344C13.5508 1.19922 13.5508 1.44531 13.6914 1.62109C14.7461 2.78125 15.3438 4.29297 15.3438 5.875C15.3438 7.49219 14.7461 9.00391 13.6914 10.1641C13.5508 10.3398 13.5508 10.5859 13.7266 10.7617L14.1133 11.1484C14.2891 11.3242 14.5703 11.3242 14.7461 11.1484C15.9766 9.74219 16.75 7.91406 16.75 5.875C16.75 3.87109 15.9766 2.04297 14.7461 0.636719C14.5703 0.460938 14.2891 0.460938 14.1133 0.636719ZM12.5312 2.21875L12.1094 2.64062C11.9688 2.78125 11.9688 3.02734 12.1094 3.20312C12.7422 3.94141 13.0938 4.89062 13.0938 5.875C13.0938 6.89453 12.7422 7.84375 12.1094 8.58203C11.9688 8.75781 11.9688 9.00391 12.1094 9.14453L12.5312 9.56641C12.707 9.74219 12.9883 9.70703 13.1289 9.53125C13.9727 8.54688 14.5 7.28125 14.5 5.875C14.5 4.50391 13.9727 3.23828 13.1289 2.25391C12.9883 2.07812 12.707 2.04297 12.5312 2.21875Z" fill="#E09C00"/>`,
        }}
      />
    </Wrapper>
  );
};

const ConversationIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M16 5H13V2C13 0.90625 12.0938 0 11 0H2C0.875 0 0 0.90625 0 2V7C0 8.125 0.875 9 2 9H3V10.625C3 10.875 3.15625 11 3.375 11C3.4375 11 3.5 11 3.59375 10.9375L6 9.59375V12C6 13.125 6.875 14 8 14H11L14.375 15.9375C14.4688 16 14.5312 16 14.625 16C14.8125 16 15 15.875 15 15.625V14H16C17.0938 14 18 13.125 18 12V7C18 5.90625 17.0938 5 16 5ZM3 7.5H2C1.71875 7.5 1.5 7.28125 1.5 7V2C1.5 1.75 1.71875 1.5 2 1.5H11C11.25 1.5 11.5 1.75 11.5 2V7C11.5 7.28125 11.25 7.5 11 7.5H6.59375L6.25 7.71875L4.5 8.71875V7.5H3ZM16.5 12C16.5 12.2812 16.25 12.5 16 12.5H13.5V13.7188L11.7188 12.7188L11.375 12.5H8C7.71875 12.5 7.5 12.2812 7.5 12V9H11C12.0938 9 13 8.125 13 7V6.5H16C16.25 6.5 16.5 6.75 16.5 7V12Z" />`,
        }}
      />
    </Wrapper>
  );
};

const LogBookIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M4 4.75C4 4.90625 4.09375 5 4.25 5H10.75C10.875 5 11 4.90625 11 4.75V3.75C11 3.625 10.875 3.5 10.75 3.5H4.25C4.09375 3.5 4 3.625 4 3.75V4.75ZM4.25 7.5H10.75C10.875 7.5 11 7.40625 11 7.25V6.25C11 6.125 10.875 6 10.75 6H4.25C4.09375 6 4 6.125 4 6.25V7.25C4 7.40625 4.09375 7.5 4.25 7.5ZM13.5938 12.5C13.8125 12.4688 14 12.25 14 12V0.5C14 0.25 13.75 0 13.5 0H2.5C1.09375 0 0 1.125 0 2.5V13.5C0 14.9062 1.09375 16 2.5 16H13.5C13.75 16 14 15.7812 14 15.5V15C14 14.7812 13.8125 14.5625 13.5938 14.5312C13.4375 14.125 13.4375 12.9062 13.5938 12.5ZM12.3125 12.5C12.2188 13.0625 12.2188 13.9688 12.3125 14.5H2.5C1.9375 14.5 1.5 14.0625 1.5 13.5C1.5 12.9688 1.9375 12.5 2.5 12.5H12.3125ZM12.5 1.5V11H2.5C2.125 11 1.78125 11.0938 1.5 11.2188V2.5C1.5 1.96875 1.9375 1.5 2.5 1.5H12.5Z"/>`,
        }}
      />
    </Wrapper>
  );
};

const InfoIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M5.8125 0.6875C2.60156 0.6875 0 3.3125 0 6.5C0 9.71094 2.60156 12.3125 5.8125 12.3125C9 12.3125 11.625 9.71094 11.625 6.5C11.625 3.3125 9 0.6875 5.8125 0.6875ZM5.8125 3.26562C6.35156 3.26562 6.79688 3.71094 6.79688 4.25C6.79688 4.8125 6.35156 5.23438 5.8125 5.23438C5.25 5.23438 4.82812 4.8125 4.82812 4.25C4.82812 3.71094 5.25 3.26562 5.8125 3.26562ZM7.125 9.21875C7.125 9.38281 6.98438 9.5 6.84375 9.5H4.78125C4.61719 9.5 4.5 9.38281 4.5 9.21875V8.65625C4.5 8.51562 4.61719 8.375 4.78125 8.375H5.0625V6.875H4.78125C4.61719 6.875 4.5 6.75781 4.5 6.59375V6.03125C4.5 5.89062 4.61719 5.75 4.78125 5.75H6.28125C6.42188 5.75 6.5625 5.89062 6.5625 6.03125V8.375H6.84375C6.98438 8.375 7.125 8.51562 7.125 8.65625V9.21875Z" fill="#007DA4"/>`,
        }}
      />
    </Wrapper>
  );
};

const IncomingIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M17.5 10.3086L14.5625 7.55859C14.4688 7.46484 14.375 7.46484 14.2812 7.55859L13.875 7.99609C13.7812 8.08984 13.8125 8.21484 13.875 8.27734L15.7188 10.0273H12.125L11.125 12.0273H6.84375L5.84375 10.0273H2.25L4.09375 8.27734C4.1875 8.21484 4.1875 8.08984 4.125 7.99609L3.6875 7.55859C3.625 7.46484 3.5 7.46484 3.40625 7.55859L0.46875 10.3086C0.15625 10.5898 0 10.9961 0 11.4023V14.4961C0 15.3398 0.65625 15.9961 1.5 15.9961H16.5C17.3125 15.9961 18 15.3398 18 14.4961V11.4023C18 10.9961 17.8125 10.5898 17.5 10.3086ZM17 14.4961C17 14.7773 16.75 14.9961 16.5 14.9961H1.5C1.21875 14.9961 1 14.7773 1 14.4961V11.4961C1 11.2461 1.21875 10.9961 1.5 10.9961H5.25L6.25 12.9961H11.75L12.75 10.9961H16.5C16.75 10.9961 17 11.2461 17 11.4961V14.4961ZM5 5.99609H7V9.24609C7 9.68359 7.3125 9.99609 7.75 9.99609H10.25C10.6562 9.99609 11 9.68359 11 9.24609V5.99609H13C13.875 5.99609 14.3125 4.93359 13.6875 4.30859L9.6875 0.308594C9.3125 -0.0976562 8.65625 -0.0976562 8.28125 0.308594L4.28125 4.30859C3.65625 4.93359 4.09375 5.99609 5 5.99609ZM9 0.996094L13 4.99609H10V8.99609H8V4.99609H5L9 0.996094Z" fill="currentColor"/>`,
        }}
      />
    </Wrapper>
  );
};

const OutgoingIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M7.8125 0C7.53125 0 7.28125 0.25 7.28125 0.5625V5H5.34375C4.78125 5 4.5 5.6875 4.90625 6.0625L8.4375 9.8125C8.6875 10.0625 9.09375 10.0625 9.34375 9.84375L13.0625 6.09375C13.4688 5.6875 13.1875 5 12.625 5H10.5V0.5625C10.5 0.25 10.25 0 9.96875 0H7.8125ZM17.6562 10.5938L14.6875 6.90625C14.5625 6.75 14.2812 6.71875 14.125 6.875L13.25 7.78125C13.125 7.90625 13.125 8.125 13.25 8.28125L14.625 10H11.75L10.75 12H7.25L6.25 10H3.34375L4.71875 8.3125C4.84375 8.15625 4.8125 7.9375 4.6875 7.8125L3.84375 6.90625C3.6875 6.71875 3.40625 6.75 3.28125 6.90625L0.3125 10.5938C0.09375 10.875 0 11.1875 0 11.5312V14.5C0 15.3438 0.65625 16 1.5 16H16.5C17.3125 16 18 15.3438 18 14.5V11.5312C18 11.1875 17.875 10.875 17.6562 10.5938Z" fill="currentColor"/>`,
        }}
      />
    </Wrapper>
  );
};

const InfoIconGray: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M9 0.53125C4.18359 0.53125 0.28125 4.46875 0.28125 9.25C0.28125 14.0664 4.18359 17.9688 9 17.9688C13.7812 17.9688 17.7188 14.0664 17.7188 9.25C17.7188 4.46875 13.7812 0.53125 9 0.53125ZM9 16.2812C5.09766 16.2812 1.96875 13.1523 1.96875 9.25C1.96875 5.38281 5.09766 2.21875 9 2.21875C12.8672 2.21875 16.0312 5.38281 16.0312 9.25C16.0312 13.1523 12.8672 16.2812 9 16.2812ZM9 4.39844C8.15625 4.39844 7.52344 5.06641 7.52344 5.875C7.52344 6.71875 8.15625 7.35156 9 7.35156C9.80859 7.35156 10.4766 6.71875 10.4766 5.875C10.4766 5.06641 9.80859 4.39844 9 4.39844ZM10.9688 13.3281V12.4844C10.9688 12.2734 10.7578 12.0625 10.5469 12.0625H10.125V8.54688C10.125 8.33594 9.91406 8.125 9.70312 8.125H7.45312C7.20703 8.125 7.03125 8.33594 7.03125 8.54688V9.39062C7.03125 9.63672 7.20703 9.8125 7.45312 9.8125H7.875V12.0625H7.45312C7.20703 12.0625 7.03125 12.2734 7.03125 12.4844V13.3281C7.03125 13.5742 7.20703 13.75 7.45312 13.75H10.5469C10.7578 13.75 10.9688 13.5742 10.9688 13.3281Z" fill="#7D8592"/>`,
        }}
      />
    </Wrapper>
  );
};

const DownloadIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path opacity="0.5" d="M8.55928 0.547368V12L13.2525 7.30779C13.3029 7.25511 13.3634 7.21305 13.4303 7.18407C13.4973 7.15508 13.5693 7.13977 13.6423 7.13902C13.7152 7.13827 13.7876 7.15209 13.8551 7.17969C13.9226 7.20729 13.9839 7.2481 14.0355 7.29973C14.087 7.35135 14.1277 7.41275 14.1551 7.48032C14.1826 7.54789 14.1963 7.62026 14.1953 7.69318C14.1944 7.76611 14.179 7.83811 14.1498 7.90497C14.1207 7.97184 14.0785 8.0322 14.0257 8.08253L9.26005 12.8472C9.09496 13.0127 8.89883 13.144 8.6829 13.2336C8.46697 13.3232 8.23547 13.3693 8.00168 13.3693C7.76789 13.3693 7.5364 13.3232 7.32047 13.2336C7.10454 13.144 6.90841 13.0127 6.74331 12.8472L1.97936 8.08589C1.92848 8.03502 1.88812 7.97463 1.86059 7.90817C1.83305 7.8417 1.81888 7.77047 1.81888 7.69853C1.81888 7.62659 1.83305 7.55535 1.86059 7.48888C1.88812 7.42242 1.92848 7.36203 1.97936 7.31116C2.03024 7.26029 2.09065 7.21994 2.15713 7.1924C2.22361 7.16487 2.29486 7.1507 2.36681 7.1507C2.43877 7.1507 2.51002 7.16487 2.5765 7.1924C2.64298 7.21994 2.70338 7.26029 2.75426 7.31116L7.47105 12.0269V0.547368C7.47105 0.402197 7.52873 0.262972 7.6314 0.16032C7.73407 0.057669 7.87333 0 8.01853 0C8.16373 0 8.30299 0.057669 8.40566 0.16032C8.50833 0.262972 8.56601 0.402197 8.56601 0.547368H8.55928ZM16 12.4025C16 12.2574 15.9423 12.1181 15.8396 12.0155C15.737 11.9128 15.5977 11.8552 15.4525 11.8552C15.3073 11.8552 15.1681 11.9128 15.0654 12.0155C14.9627 12.1181 14.905 12.2574 14.905 12.4025V14.2215C14.9046 14.403 14.8322 14.5769 14.7036 14.7051C14.5751 14.8333 14.401 14.9053 14.2194 14.9053H1.78395C1.69378 14.9057 1.6044 14.8884 1.52093 14.8542C1.43747 14.8201 1.36157 14.7698 1.29757 14.7063C1.23357 14.6428 1.18273 14.5672 1.14796 14.4841C1.1132 14.4009 1.09519 14.3116 1.09497 14.2215V12.4025C1.09497 12.2574 1.03729 12.1181 0.934613 12.0155C0.83194 11.9128 0.692685 11.8552 0.547484 11.8552C0.402282 11.8552 0.263027 11.9128 0.160354 12.0155C0.0576811 12.1181 0 12.2574 0 12.4025V14.2215C0.000892787 14.6938 0.189292 15.1464 0.5238 15.4799C0.858308 15.8134 1.31156 16.0004 1.78395 16H14.2194C14.6912 15.9996 15.1436 15.8121 15.4774 15.4787C15.8112 15.1453 15.9991 14.6932 16 14.2215V12.4025Z" fill="currentColor"/>`,
        }}
      />
    </Wrapper>
  );
};

const MailIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="14"
        viewBox="0 0 18 14"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M16.3125 0.25H1.6875C0.738281 0.25 0 1.02344 0 1.9375V12.0625C0 13.0117 0.738281 13.75 1.6875 13.75H16.3125C17.2266 13.75 18 13.0117 18 12.0625V1.9375C18 1.02344 17.2266 0.25 16.3125 0.25ZM1.6875 1.375H16.3125C16.5938 1.375 16.875 1.65625 16.875 1.9375V3.41406C16.1016 4.04688 14.9766 4.96094 11.5664 7.66797C10.9688 8.16016 9.80859 9.28516 9 9.25C8.15625 9.28516 6.99609 8.16016 6.39844 7.66797C2.98828 4.96094 1.86328 4.04688 1.125 3.41406V1.9375C1.125 1.65625 1.37109 1.375 1.6875 1.375ZM16.3125 12.625H1.6875C1.37109 12.625 1.125 12.3789 1.125 12.0625V4.85547C1.89844 5.52344 3.16406 6.54297 5.69531 8.54688C6.43359 9.14453 7.69922 10.4102 9 10.375C10.2656 10.4102 11.5312 9.14453 12.2695 8.54688C14.8008 6.54297 16.0664 5.52344 16.875 4.85547V12.0625C16.875 12.3789 16.5938 12.625 16.3125 12.625Z" fill="currentColor"/>`,
        }}
      />
    </Wrapper>
  );
};

const RollBackIcon: React.FC<React.ComponentProps<typeof Wrapper>> = () => {
  return (
    <Wrapper>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        dangerouslySetInnerHTML={{
          __html: `<path d="M0.703125 0.28125C0.457031 0.28125 0.28125 0.492188 0.28125 0.703125V6.32812C0.28125 6.57422 0.457031 6.75 0.703125 6.75H6.32812C6.53906 6.75 6.75 6.57422 6.75 6.32812V5.97656C6.75 5.76562 6.53906 5.55469 6.32812 5.55469H2.28516C3.55078 3.16406 6.08203 1.47656 9 1.47656C13.1484 1.47656 16.5234 4.88672 16.5234 9C16.5234 13.1836 13.1133 16.5234 9 16.5234C7.03125 16.5234 5.27344 15.8203 3.9375 14.625C3.79688 14.4492 3.51562 14.4844 3.375 14.625L3.12891 14.8711C2.95312 15.0469 2.95312 15.3281 3.12891 15.5039C4.67578 16.875 6.75 17.7188 9 17.7188C13.7812 17.7188 17.6836 13.8516 17.7188 9.03516C17.7188 4.25391 13.8164 0.316406 9 0.316406C5.80078 0.28125 2.98828 2.03906 1.47656 4.60547V0.703125C1.47656 0.492188 1.26562 0.28125 1.05469 0.28125H0.703125Z" fill="currentColor"/>`,
        }}
      />
    </Wrapper>
  );
};

export {
  DashBoardIcon,
  CallCenterIcon,
  SocialMediaIcon,
  InvoicesIcon,
  ParingIcon,
  SideBarIcon,
  PrinterIcon,
  FilterIcon,
  TagIcon,
  ListViewIcon,
  SingleViewIcon,
  AttachmentIcon,
  CallBackIcon,
  LogBookIcon,
  ConversationIcon,
  InfoIcon,
  IncomingIcon,
  OutgoingIcon,
  InfoIconGray,
  DownloadIcon,
  MailIcon,
  RollBackIcon,
};
